import { Actions } from '@ngrx/effects';
import { BaseResourceEffects } from '../base-resource.effects';
import { meetingTypeActions } from './meeting-type.actions';
import { MeetingTypeService } from '../../services/meeting-type.service';
import { CoreAppState } from '../core-app.state';
import { Injectable } from '@angular/core';
import { selectMeetingTypeState } from './meeting-type.reducer';
import { Store } from '@ngrx/store';
import { MeetingTypeResourceTypeMappings } from '@aa/nest/resource';

@Injectable()
export class MeetingTypeEffects extends BaseResourceEffects<MeetingTypeResourceTypeMappings> {
  constructor(
    protected override readonly actions$: Actions,
    protected override readonly store: Store<CoreAppState>,
    protected override readonly service: MeetingTypeService,
  ) {
    super(actions$, store, service, meetingTypeActions, selectMeetingTypeState);
  }
}
